export const LabelBlueBold = ({content}) => (
  <label className="text-primary-blue font-weight-bold mt-2 mb-3">
    {content}
  </label>
);
